module.exports = __webpack_public_path__ + "static/media/preguntas_dep_voto.d783e231.svg";